import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg?._retry && !cfg?.url?.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "حدث خطأ، حاول مرة أخرى";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const SUBJECTS = [
  { id: "arabic", ar: "العربية", native: "العربية", glyph: "ض", desc: "", tone: "#047857" },
  { id: "english", ar: "الإنجليزية", native: "English", glyph: "Ee", desc: "قصص متدرجة، مقالات، ونثر حديث وكلاسيكي", tone: "#1E3A5F" },
];

export const LEVELS = [
  { n: 1, name: "مبتدئ", cefr: "A1–A2", desc: "جمل قصيرة ومفردات يومية" },
  { n: 2, name: "متوسط", cefr: "B1", desc: "قصص قصيرة وتراكيب أوضح" },
  { n: 3, name: "متقدم", cefr: "B2–C1", desc: "نصوص أدبية وأسلوب غني" },
  { n: 4, name: "مُتقن", cefr: "C2", desc: "مقالات فكرية ونصوص عميقة" },
];


// File names that are only numbers ("12.pdf") are not real titles, so they are left empty.
export const guessTitle = (name) => {
  const s = String(name || "").replace(/\.pdf$/i, "").trim();
  return /^[\d\s._()-]+$/.test(s) ? "" : s;
};
